module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/fd78ba346011c6d9b8362d120be53d70.png";